<header>
  <h3 class="menu-label">
    <span [id]="label | joinWithHyphens">{{ label }}</span>
    <span *ngIf="control.value.length" class="selection-count">
      {{ control.value.length }}
    </span>
  </h3>
  <iris-icon-button
    (click)="cancel()"
    (keyup)="onKeyUp($event)"
    class="close-button"
    icon="close"
    ariaLabel="Close menu"
    [type]="tertiaryIrisIconButtonType"
  ></iris-icon-button>
</header>
<main
  data-test="select-menu-listbox filter-select-listbox"
  role="listbox"
  [attr.aria-labelledby]="label | joinWithHyphens"
  #listbox
>
  <ng-container *ngFor="let category of categorizedOptions">
    <ul
      [attr.aria-labelledby]="category.name | joinWithHyphens"
      [attr.aria-multiselectable]="true"
    >
      <h4 class="category-label" [id]="category.name | joinWithHyphens">
        {{ category.name }}
      </h4>
      <ng-container *ngFor="let option of category.options; let i = index">
        <li
          *ngIf="showAll || !category.trimmedListCount || i < category.trimmedListCount"
          class="filter-select-list-item"
          [ngClass]="{'selected': option.value && (control.value | isOptionInSelections:option.value:compareOptionsFn)}"
          [id]="'dropdown-option' + i"
          (click)="updateMultiFormControl(option.value)"
          (focus)="onFocusListItem(option.value)"
          (mousedown)="$event.preventDefault()"
          (mouseenter)="onHoverEnter(option.value)"
          (mouseleave)="onHoverLeave()"
          (keydown)="onMobileSelectKeyDown($event)"
          (keyup)="onKeyUp($event)"
          (keyup.escape)="cancel()"
          [attr.aria-selected]="(control.value | isOptionInSelections:option.value:compareOptionsFn)"
          [attr.aria-label]="option.name"
          role="option"
          tabindex="0"
        >
          <div class="iris-checkbox">
            <div
              class="iris-checkbox-highlight-circle"
              [ngClass]="{'show-highlight': currentHoveredValue === option.value}"
            ></div>
            <div
              class="iris-checkbox-box"
              [ngClass]="{
                'is-checked': option.value && (control.value | isOptionInSelections:option.value:compareOptionsFn),
                'is-highlighted': currentHoveredValue === option.value
              }"
            >
              <div class="iris-checkmark" >
                <div class="iris-checkmark-right iris-checkmark-half"></div>
                <div class="iris-checkmark-left iris-checkmark-half"></div>
              </div>
            </div>
          </div>
          <span class="filter-select-list-item-label">{{ option.name }}</span>
        </li>
      </ng-container>
    </ul>
    
    <button
      *ngIf="!showAll && category.trimmedListCount && category.options.length > category.trimmedListCount"
      class="show-more-button"
      (click)="showAllOptions()"
      (keydown)="onButtonKeyDown($event)"
      (keyup)="onKeyUp($event)"
    >
      Show more
    </button>
  </ng-container>
</main>
<footer>
  <iris-button
    [type]="tertiaryIrisButtonType"
    [disabled]="!control.value.length"
    [typeAttribute]="resetButtonType"
    (click)="resetValue()"
    (keydown)="onButtonKeyDown($event)"
    (keyup)="onKeyUp($event)"
    class="clear-selections-button"
  >
    Clear selection
  </iris-button>
  <iris-button
    [type]="primaryIrisButtonType"
    [typeAttribute]="submitButtonType"
    (click)="confirm()"
    (keydown)="onButtonKeyDown($event)"
    (keyup)="onKeyUp($event)"
    class="see-results-button"
  >
    See results
  </iris-button>
</footer>
